import Select from 'react-select';
import { getTranslatedText, formatGroupLabel } from '@nile/components';
import { AccountClient, GET_INVOICE_PAYMENT_TERMS } from '@nile/graphql';
import React, { useState } from 'react';
import styled from 'styled-components';

import { useLazyQuery } from '@apollo/client';

const TermSelectDropdownContainer = styled.div`
  min-width: 170px;
  .value_selector__control {
    border: none;
    border-radius: 0;
    border-bottom: 1px solid #ececec;
  }
  .value_selector__single-value {
    font-weight: bold;
  }
  .value_selector__indicator-separator {
    display: none;
  }
  .value_selector__value-container {
    padding-left: 8px;
  }
`;

function TermSelectDropdown(props) {
  const { intl, key, defaultValue, onChange, value, placeholder } = props;
  const [menuOpen, setMenuOpen] = useState(false);
  const [paymentTerms, setPaymentTerms] = useState([]);
  const [fetchValues, { loading: termsLoading }] = useLazyQuery(
    GET_INVOICE_PAYMENT_TERMS,
    {
      client: AccountClient,
      fetchPolicy: 'cache-and-network',
      onCompleted: ({ getPaymentTerms }) => {
        if (getPaymentTerms) {
          const paymenTerms = [
            {
              label: getTranslatedText(
                intl,
                'client.invoice.settings.paymentTerm.systemTerms'
              ),
              options: getPaymentTerms
                .filter((opt) => opt.systemPaymentTerm)
                .map((term) => ({
                  ...term,
                  label: term.paymentTermName,
                  value: term.paymentTermId
                }))
            },
            {
              label: getTranslatedText(
                intl,
                'client.invoice.settings.paymentTerm.userTerms'
              ),
              options: getPaymentTerms
                .filter((opt) => !opt.systemPaymentTerm)
                .map((term) => ({
                  ...term,
                  label: term.paymentTermName,
                  value: term.paymentTermId
                }))
            }
          ];
          setPaymentTerms(paymenTerms);
        }
      }
    }
  );

  return (
    <TermSelectDropdownContainer>
      <Select
        className="propSelector"
        onMenuOpen={async () => {
          await fetchValues();
          setMenuOpen(true);
        }}
        onMenuClose={() => {
          setMenuOpen(false);
        }}
        key={key}
        value={value}
        classNamePrefix="value_selector"
        formatGroupLabel={formatGroupLabel}
        defaultValue={defaultValue}
        onChange={onChange}
        options={paymentTerms}
        placeholder={getTranslatedText(
          intl,
          placeholder || 'admin.slaPolicy.chooseValue'
        )}
        menuPortalTarget={document.body}
        menuPlacement="auto"
        noOptionsMessage={() => {
          return termsLoading ? 'Loading...' : 'No options';
        }}
        isMulti={false}
        isLoading={termsLoading}
        menuIsOpen={menuOpen}
        styles={{
          menuPortal: (base) => ({ ...base, zIndex: 9999 }),
          menu: (base) => ({ ...base, zIndex: 9999 })
        }}
        closeMenuOnScroll={(e) => {
          return (
            e.target &&
            e.target.classList &&
            !(e.target.classList.value.indexOf('menu-list') > -1)
          );
        }}
      />
    </TermSelectDropdownContainer>
  );
}

export default TermSelectDropdown;
